"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_modal_1 = __importDefault(require("react-modal"));
const react_1 = require("react");
const TextAreaWeb_1 = __importDefault(require("../common/TextAreaWeb"));
const ButtonWeb_1 = __importDefault(require("../common/ButtonWeb"));
const pilotHandlers_1 = require("../../handlers/pilotHandlers");
const account_1 = require("../../store/redux/account");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const BioModal = ({ modalVisible, setModalVisible, userIsPilot, bio }) => {
    const [data, setData] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        bio && setData(bio);
    }, []);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'account.set_profile' });
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, { isOpen: modalVisible, onRequestClose: () => {
            setModalVisible(false);
            setData('');
        }, contentLabel: "Pilot details", className: "modal-body", overlayClassName: "modal-overlay", appElement: document.getElementById("app-root"), children: [(0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)("div", { className: "header", children: (0, jsx_runtime_1.jsx)("span", { className: "subtitle-bold", children: t(userIsPilot ? 'bio_edit' : 'bio_add') }) }), (0, jsx_runtime_1.jsx)("div", { className: "input-box", children: (0, jsx_runtime_1.jsxs)("label", { className: "input-label", children: [t('bio'), (0, jsx_runtime_1.jsx)(TextAreaWeb_1.default, { className: "input-web", value: data, onChange: value => setData(value), placeholder: t('enter_bio') })] }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Blue", fullWidth: true, isDisabled: !data, onClick: () => {
                            userIsPilot ?
                                (0, pilotHandlers_1.editPilotProfileHandler)({ 'bio': data }) :
                                dispatch((0, account_1.setPilotProfileAction)({ bio: data }));
                            setModalVisible(false);
                        }, children: t('save') }), (0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "White-BlueFont", fullWidth: true, onClick: () => {
                            setModalVisible(false);
                            setData('');
                        }, children: t('cancel') })] })] }));
};
exports.default = BioModal;
